import React from "react";
import { Helmet } from "react-helmet";

const Contact = () => {
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="description"
          content="Our firm offers comprehensive services in corporate law, regulatory compliance, risk management, and dispute resolution, providing practical, proactive, and innovative solutions"
        />
        <title>Contact Us</title>
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="keywords"
          content="
  legal compliance services,
  regulatory compliance consultants,
  corporate law firm,
  legal advisory services,
  insurance compliance solutions,
  legal risk management,
  dispute resolution experts,
  corporate legal services,
  compliance and legal advisory,
  legal consulting firm,
  legal and insurance compliance,
  regulatory risk management,
  business law solutions,
  legal compliance specialists,
  corporate governance consultants,
  proactive legal support,
  legal compliance for businesses,
  Legal Nest legal services,
  Legal Nest compliance advisors,
  agile legal firm in India,
  modern legal compliance firm,
  expert regulatory compliance team,
  Legal Nest corporate law solutions
"
        />

        <meta name="author" content="Mantra Jha" />
      </Helmet>{" "}
      <div id="content" className="site-content">
        <div
          className="page-title-wrap text-center parallax"
          style={{ padding: "", backgroundAttachment: "fixed" }}
        >
          <div className="container">
            <h1 className="page-title" style={{ color: "" }}>
              <span>Get in touch with us</span>
            </h1>
          </div>
        </div>
        <div className="container ct-lv1">
          <div className="row">
            <div
              id="primary"
              className="content-area content-page col-xs-12 col-sm-12 col-md-12 col-lg-12"
            >
              <main id="main" className="site-main" role="main">
                <div
                  id="post-14"
                  className="post-14 page type-page status-publish hentry"
                >
                  <div className="entry-content">
                    <div className="wpb-content-wrapper">
                      <div className="vc_row wpb_row vc_row-fluid">
                        <div className="wpb_column vc_column_container vc_col-sm-8">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div
                                className="st-custom-heading-wraper st-custom-heading-layout1 text-default"
                                style={{ marginBottom: "" }}
                              >
                                <h2
                                  className="st-heading-title"
                                  style={{ color: "" }}
                                >
                                  <span className="heading-text">
                                    Send message
                                  </span>
                                </h2>
                                <hr
                                  className="heading-line"
                                  style={{ background: "" }}
                                />
                              </div>
                              <div
                                className="wpcf7 no-js"
                                id="wpcf7-f283-p14-o1"
                                lang="en-US"
                                dir="ltr"
                                data-wpcf7-id={283}
                              >
                                <div className="screen-reader-response">
                                  <p
                                    role="status"
                                    aria-live="polite"
                                    aria-atomic="true"
                                  />
                                  <ul />
                                </div>
                                <form
                                  action="https://formsubmit.co/info@legalnest.co"
                                  method="post"
                                  className="wpcf7-form init"
                                  aria-label="Contact form"
                                  noValidate="novalidate"
                                  data-status="init"
                                >
                                  <div style={{ display: "none" }}>
                                    <input
                                      type="hidden"
                                      name="_wpcf7"
                                      defaultValue={283}
                                    />
                                    <input
                                      type="hidden"
                                      name="_wpcf7_version"
                                      defaultValue={6.0}
                                    />
                                    <input
                                      type="hidden"
                                      name="_wpcf7_locale"
                                      defaultValue="en_US"
                                    />
                                    <input
                                      type="hidden"
                                      name="_wpcf7_unit_tag"
                                      defaultValue="wpcf7-f283-p14-o1"
                                    />
                                    <input
                                      type="hidden"
                                      name="_wpcf7_container_post"
                                      defaultValue={14}
                                    />
                                    <input
                                      type="hidden"
                                      name="_wpcf7_posted_data_hash"
                                      defaultValue=""
                                    />
                                  </div>
                                  <div className="col2 pull-left">
                                    <p>
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="your-name"
                                      >
                                        <input
                                          size={40}
                                          maxLength={400}
                                          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Name*"
                                          defaultValue=""
                                          required
                                          type="text"
                                          name="Name"
                                        />
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col2 pull-right">
                                    <p>
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="your-email"
                                      >
                                        <input
                                          size={40}
                                          maxLength={400}
                                          className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Email*"
                                          defaultValue=""
                                          required
                                          type="email"
                                          name="Email"
                                        />
                                      </span>
                                    </p>
                                  </div>

                                  <div>
                                    <p>
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="your-message"
                                      >
                                        <input
                                          size={40}
                                          maxLength={400}
                                          className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Phone Number*"
                                          defaultValue=""
                                          required
                                          type="number"
                                          name="Phone Number"
                                          style={{ width: "100%" }}
                                        />
                                      </span>
                                      <input
                                        type="hidden"
                                        name="_captcha"
                                        value="false"
                                      ></input>
                                      <input
                                        type="hidden"
                                        name="_next"
                                        value="https://legal-nest.vercel.app/"
                                      ></input>
                                    </p>
                                  </div>

                                  <div>
                                    <p>
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="your-message"
                                      >
                                        <textarea
                                          cols={40}
                                          rows={10}
                                          maxLength={2000}
                                          className="wpcf7-form-control wpcf7-textarea"
                                          aria-invalid="false"
                                          required
                                          placeholder="Message"
                                          name="Message"
                                          defaultValue={""}
                                        />
                                      </span>
                                      <input
                                        type="hidden"
                                        name="_template"
                                        value="box"
                                      ></input>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      <input
                                        className="wpcf7-form-control wpcf7-submit has-spinner tertiary-background"
                                        type="submit"
                                        defaultValue="SEND NOW"
                                      />
                                    </p>
                                  </div>
                                  <div
                                    className="wpcf7-response-output"
                                    aria-hidden="true"
                                  />
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-4">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div
                                className="st-custom-heading-wraper st-custom-heading-layout1 text-default"
                                style={{ marginBottom: "" }}
                              >
                                <h2
                                  className="st-heading-title"
                                  style={{ color: "" }}
                                >
                                  <span className="heading-text">
                                    Contact Details
                                  </span>
                                </h2>
                                <hr
                                  className="heading-line"
                                  style={{ background: "" }}
                                />
                              </div>
                              <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                <div className="st-feature-box">
                                  <div className="st-feature-box-icon">
                                    <div className="feature-box-image">
                                      <img
                                        decoding="async"
                                        src="../wp-content/uploads/2015/11/icontact1.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>

                                  <h3>Address Mumbai</h3>
                                  <div className="feature-box-content">
                                    NESCO IT Park, Building 4, North Wing,
                                    Western Express Hwy, Goregaon, Mumbai,
                                    Maharashtra, 400063
                                  </div>
                                  <br />
                                </div>
                              </div>

                              <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                <div className="st-feature-box">
                                  <div className="st-feature-box-icon">
                                    <div className="feature-box-image">
                                      <img
                                        decoding="async"
                                        src="../wp-content/uploads/2015/11/icontact1.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>

                                  <h3>Address Delhi</h3>
                                  <div className="feature-box-content">
                                    A-98, Rear Basement, New Friends Colony, New
                                    Delhi - 110025
                                  </div>
                                </div>
                              </div>

                              <br />
                              <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                <div className="st-feature-box">
                                  <div className="st-feature-box-icon">
                                    <div className="feature-box-image">
                                      <img
                                        decoding="async"
                                        src="../wp-content/uploads/2015/11/icontact1.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>

                                  <h3>Address Hyderabad</h3>
                                  <div className="feature-box-content">
                                    406, Lake Melody, Raj Bhavan Road,
                                    Somajiguda, Hyderabad – 500082
                                  </div>
                                </div>
                              </div>

                              <div
                                className="vc_empty_space"
                                style={{ height: 32 }}
                              >
                                <span className="vc_empty_space_inner" />
                              </div>
                              <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                <div className="st-feature-box">
                                  <div className="st-feature-box-icon">
                                    <div className="feature-box-image">
                                      <img
                                        decoding="async"
                                        src="../wp-content/uploads/2015/11/icontact2.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <h3>Phone</h3>
                                  <div className="feature-box-content">
                                    +91 9076040468 / +91 8860783250
                                  </div>
                                </div>
                              </div>
                              <div
                                className="vc_empty_space"
                                style={{ height: 32 }}
                              >
                                <span className="vc_empty_space_inner" />
                              </div>
                              <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                <div className="st-feature-box">
                                  <div className="st-feature-box-icon">
                                    <div className="feature-box-image">
                                      <img
                                        decoding="async"
                                        src="../wp-content/uploads/2015/11/icontact3.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <h3>Email</h3>
                                  <div className="feature-box-content">
                                    info@legalNest.co
                                  </div>
                                </div>
                              </div>
                              <div
                                className="vc_empty_space"
                                style={{ height: 32 }}
                              >
                                <span className="vc_empty_space_inner" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="vc_row-full-width vc_clearfix" />
                    </div>
                  </div>
                  {/* .entry-content */}
                  <div className="page-edit" />
                  {/* .entry-footer */}
                </div>
                {/* #post-## */}
              </main>
              {/* #main */}
            </div>
            {/* #primary */}
          </div>
          {/* #row */}
        </div>
        {/* #container */}
      </div>
    </>
  );
};

export default Contact;
